module.exports = __webpack_public_path__ + "img/bg-ds.f31ce845.png";